module.exports = __webpack_public_path__ + "img/icon-xs.3a67d17a.png";